// react
import React from 'react';

// material ui
import { Box, Divider, List, Typography } from '@mui/material';

// relative
import type { NavItem, NavSection as NavSectionType } from './navigationTypes';
import { NavItem as NavItemComponent } from './NavItem';

interface NavSectionProps {
  section: NavSectionType;
  isLast: boolean;
  drawerOpen?: boolean;
  isExpanded: (item: NavItem) => boolean;
  onToggle: (itemId: string, currentExpandedState: boolean) => void;
  onPopperOpen: (
    event: React.MouseEvent<HTMLElement>,
    children: NavItem[],
    itemId: string,
  ) => void;
  onPopperClose: (delay?: number) => void;
}

export const NavSection: React.FC<NavSectionProps> = ({
  section,
  isLast,
  drawerOpen = true,
  isExpanded,
  onToggle,
  onPopperOpen,
  onPopperClose,
}) => {
  return (
    <Box>
      {drawerOpen && (
        <Typography
          variant="subtitle2"
          sx={{
            px: 1,
            pt: 1,
            display: 'block',
            fontWeight: 600,
            color: (theme) => theme.palette.text.primary,
          }}
        >
          {section.title}
        </Typography>
      )}

      <List
        component="nav"
        dense
        sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}
      >
        {section.items.map((item) => (
          <NavItemComponent
            key={item.id}
            item={item}
            drawerOpen={drawerOpen}
            isExpanded={isExpanded}
            onToggle={onToggle}
            onPopperOpen={onPopperOpen}
            onPopperClose={onPopperClose}
          />
        ))}
      </List>

      {!isLast && <Divider sx={{ my: 0.5 }} />}
    </Box>
  );
};
